import styled from 'styled-components';
import { Box } from 'reflexbox';

export const PharmacyCountsBox = styled(Box)`
  margin: 20px 0;
`;

export const PharmacyRow = styled(Box)`
  background: #F9F9F9;
  border-bottom: 1px solid #E0E0E0;
  padding: 10px 25px;
  display: flex;
  justify-content: space-between;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  align-items: center;
`;

export const PharmacyRowDetails = styled(PharmacyRow)`
  justify-content: flex-start;
  padding: 10px;
`;

export const OrdersCountLabel = styled(Box)`
  border-radius: 20px;
  color: #FFFFFF;
  padding: 8px 10px;
  min-width: 54px;
  text-align: center;
`;

export const RedOrdersCountLabel = styled(OrdersCountLabel)(({ disabled = false }) => ({
  background: disabled ? '#FAEBE9' : '#EB4D3D',
  color: disabled ? '#F09288' : '#fff',
}));

export const GreenOrdersCountLabel = styled(OrdersCountLabel)(({ disabled = false }) => ({
  background: disabled ? '#D6F3E3' : '#519A71',
  color: disabled ? '#8BB59D' : '#fff',
}));

export const GreyOrdersCountLabel = styled(OrdersCountLabel)(({ disabled = false }) => ({
  background: disabled ? '#EFEFEF' : '#939393',
  color: disabled ? '#8BB59D' : '#fff',
}));

export const PendingOrdersList = styled(Box)`
  margin-top: 15px;
`;
